<form
  novalidate
  role="form"
  [attr.aria-label]="'Sign In Form' | translate"
  [formGroup]="form"
  (submit)="hasTwoFactor() ? loginWithOtp() : login()"
>
  @if (!hasTwoFactor()) {
    <tn-form-field class="username-input" [label]="'Username' | translate">
      <tn-input
        formControlName="username"
        name="username"
        autocomplete="username"
        [testId]="'username'"
        [ariaLabel]="'Username' | translate"
        [prefixIcon]="tnIconMarker('account', 'mdi')"
      ></tn-input>
    </tn-form-field>

    <tn-form-field class="password-input" [label]="'Password' | translate">
      <tn-input
        formControlName="password"
        name="password"
        autocomplete="current-password"
        suffixActionTestId="toggle-password-password"
        [testId]="'password'"
        [ariaLabel]="'Password' | translate"
        [inputType]="isPasswordVisible() ? InputType.PlainText : InputType.Password"
        [prefixIcon]="tnIconMarker('lock', 'mdi')"
        [suffixIcon]="isPasswordVisible() ? tnIconMarker('eye', 'mdi') : tnIconMarker('eye-off', 'mdi')"
        [suffixIconAriaLabel]="isPasswordVisible() ? ('Hide Password' | translate) : ('Show Password' | translate)"
        (onSuffixAction)="togglePasswordVisibility()"
      ></tn-input>
    </tn-form-field>

    @if (showSecurityWarning()) {
      <tn-banner
        type="warning"
        [testId]="'insecure-connection'"
        [bordered]="true"
        [heading]="'Connection is insecure' | translate"
        [message]="'You are using an insecure connection. Switch to HTTPS for secure access.' | translate"
      ></tn-banner>
    }

    <tn-button
      class="submit-button"
      type="submit"
      color="primary"
      [testId]="'log-in'"
      [label]="isSubmitting() ? ('Logging in...' | translate) : ('Log In' | translate)"
      [disabled]="isFormDisabled()"
    ></tn-button>
    @if (isLastLoginAttemptFailed()) {
      <div class="error" tnTestIdType="text" [tnTestId]="'login-error'">
        <p [innerHTML]="lastLoginError()"></p>
      </div>
    }
  }
  @if (hasTwoFactor()) {
    <tn-banner
      class="otp-banner"
      type="info"
      [bordered]="true"
      [heading]="'Enter one-time password' | translate"
      [message]="'2FA has been configured for this account. Enter the OTP to continue.' | translate"
    ></tn-banner>

    <tn-form-field
      class="otp-input"
      [label]="'Two-Factor Authentication Code' | translate"
      [errorMessages]="otpErrorMessages"
    >
      <tn-input
        formControlName="otp"
        name="otp"
        autocomplete="one-time-code"
        [testId]="'otp'"
        [ariaLabel]="'Two-Factor Authentication Code' | translate"
        [required]="true"
        [prefixIcon]="tnIconMarker('cellphone-link', 'mdi')"
      ></tn-input>
    </tn-form-field>

    <div>
      <tn-button
        class="submit-button"
        type="submit"
        color="primary"
        [testId]="'log-in'"
        [label]="isSubmitting() ? ('Logging in...' | translate) : ('Proceed' | translate)"
        [disabled]="isFormDisabled()"
      ></tn-button>
      <tn-button
        class="submit-button"
        [testId]="'otp-log-in'"
        [label]="'Cancel' | translate"
        [disabled]="isFormDisabled()"
        (onClick)="cancelOtpLogin()"
      ></tn-button>
    </div>
  }
</form>
